var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block" }, [
    _c("div", { staticClass: "block-header" }, [
      _c("div", { staticClass: "header-info" }, [
        _c(
          "h4",
          { staticClass: "block-header-title is-size-4" },
          [_vm._t("header", [_vm._v("Default Header")])],
          2
        ),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "is-marginless is-size-7" },
          [_vm._t("subheader")],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [_vm._t("actions")], 2)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-per-type" }, [
      _c("div", { staticClass: "total-item" }, [
        _c(
          "span",
          {
            staticClass: "total-pendientes",
            staticStyle: { "font-size": "1.5rem", "margin-right": "-3px" }
          },
          [_vm._v(_vm._s(_vm.totalPending))]
        ),
        _vm._v(" "),
        _c("img", {
          staticClass: "icon icon-svg",
          attrs: {
            src: require("@/static/svg/icono_pendiente_v2.svg"),
            alt: "pendiente"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "total-item" }, [
        _c(
          "span",
          {
            staticClass: "total-completados",
            staticStyle: { "font-size": "1.5rem", "margin-right": "-3px" }
          },
          [_vm._v(_vm._s(_vm.totalCompleted))]
        ),
        _vm._v(" "),
        _c("img", {
          staticClass: "icon icon-svg",
          attrs: {
            src: require("@/static/svg/icono_check_v2.svg"),
            alt: "completado"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "total-item" }, [
        _c(
          "span",
          {
            staticClass: "total-fallidos",
            staticStyle: { "font-size": "1.5rem", "margin-right": "-3px" }
          },
          [_vm._v(_vm._s(_vm.totalFailed))]
        ),
        _vm._v(" "),
        _c("img", {
          staticClass: "icon icon-svg",
          attrs: {
            src: require("@/static/svg/icono_nocheck_v2.svg"),
            alt: "fallido"
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }